import { HimuraInject } from 'himura';
import { DataDelegate } from '../data.delegate';
import * as T_T from 'cryface';
import { CommonConfig } from '../../../configs/config.common';
import { IBlogData } from '../../../models/blog.models';
import { AxiosPromise } from '../../../utils/axios.promise';

@HimuraInject.NamedService('BlogListDelegate')
export class BlogListDelegate extends DataDelegate {
    private commonConfigs: CommonConfig = new CommonConfig();
    constructor() {
        super('BlogListDelegate');
    }

    public async getBlogs(userid: number, page: number): Promise<IBlogData> {
        // await T_T.delay(2000);
        // const dataSource = new DummyDataDelegate();
        // this.Data = await dataSource.fetchData();
        // return 1;
        const apiHost: string = this.commonConfigs.cmisapiHost;
        const fetched: any = await AxiosPromise.get(`${apiHost}/blogArticle/pageListByUserId?userId=${userid}&ltype=1&pageSize=10&pageNum=${page}`);
        if (T_T.simpleDetect(fetched) && fetched.code === 200) {
            const iblog: IBlogData = this.dataMapping(fetched);
            // this.Data = iblog;
            return iblog;
        } else {
            const a: IBlogData = {
                pageNo : 0,
                data : [],
                totalPage : 0,
                totalRecord : 0,
                code : fetched.code
            };
            return a;
        }
    }

    private dataMapping(data: any): IBlogData {
        const iblog: IBlogData = {
            code: T_T.simpleDetect(data.pageNo) ? data.pageNo : 0,
            pageNo: T_T.simpleDetect(data.pageNo) ? data.pageNo : 0,
            totalPage: T_T.simpleDetect(data.totalPage) ? data.totalPage : 0,
            totalRecord: T_T.simpleDetect(data.totalRecord) ? data.totalRecord : 0,
            data: T_T.simpleDetect(data.data) ? data.data : []
        };
        return iblog;
    }

    public listingAgentOneMapper(data: any) {
        if (T_T.simpleDetect(data.radarListings)) {
            if (T_T.simpleDetect(data.radarListings.agentList)) {
                if (data.radarListings.agentList.length > 0) {
                    if (T_T.simpleDetect(data.radarListings.agentList[0].name)) {
                        return data.radarListings.agentList[0].name;
                    }
                }
            }
        }
        return '';
    }

    public listingAgentTwoMapper(data: any) {
        if (T_T.simpleDetect(data.radarListings)) {
            if (T_T.simpleDetect(data.radarListings.agentList)) {
                if (data.radarListings.agentList.length > 1) {
                    if (T_T.simpleDetect(data.radarListings.agentList[1].name)) {
                        return data.radarListings.agentList[1].name;
                    }
                }
            }
        }
        return '';
    }
}
